import React from 'react';
import { useModal } from '../../../../components/Modal/PresentedModal';
import { FormForm } from '../../../../components/Form/FormForm';
import { t } from '../../../../locales/translate';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { handleError } from '../../../../model/notification';
import { FormFileUpload } from '../../../../components/Form/FileUpload/FormFileUpload';
import { runVoucherCodesImport } from '../../../../model/imports';
import { useApolloClient } from '@apollo/client';
import { QueryNames } from '../../../../model/graphql';

interface Props {
  id: string;
}

export function VoucherCodeImport({ id }: Props): JSX.Element {
  const { import: translation } = t.page.voucherCampaign.voucherCodes;
  const { open, Modal, close, size } = useModal();
  const apollo = useApolloClient();

  const { fields, dirty, valid, submissionStatus, onSubmit } = useForm<{
    file?: File;
  }>({
    model: {},
    onSubmit: async ({ model }) => {
      if (!model.file) return;
      await runVoucherCodesImport(id, model.file);
      apollo.refetchQueries({
        include: [QueryNames.VOUCHER_CODES],
      });
      close();
    },
    validations: {
      file: 'required',
    },
    onSubmitError: handleError,
  });

  return (
    <Modal open={open} title={translation.importCsv} size={size}>
      <FormForm
        onSubmit={onSubmit}
        onClose={close}
        canSubmit={dirty && valid}
        saveButtonTitle={translation.import}
        loading={submissionStatus === 'submitting'}
      >
        <FormFileUpload
          accept="text/csv"
          label={translation.attachment}
          description={translation.description}
          name="file"
          {...fields.file}
        />
      </FormForm>
    </Modal>
  );
}
